module.exports = __webpack_public_path__ + "static/assets/0b8771011ab65dbb2a935a9d06995ccb.png";